import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actions} from 'react-redux-form'
import {Link} from 'react-router-dom'
import {Grid, Button} from 'react-bootstrap'
import BrandsList from "./brands-list";
import ProductSearchComponent from '../../../../common/search/simple-search-component'
import PageTitle from "../../../../common/page-title/index";
import ArrowButton from "../../../../common/button-arrow";
import {getBrands} from '../../../../../actions/brands'

import '../../common/styles.css'

class Brands extends Component {
  constructor(props){
    super(props);

    this.state = {
      query: ''
    }
  }

  componentWillMount() {
    this.props.dispatch(actions.reset('deep.admin_brand'));
    this.props.dispatch({type: 'CLEAR_EDIT_BRAND'});
    this.props.dispatch(getBrands());
  }

  handleInputChange = (e) => {
    this.setState({query: e.target.value});
  };

  handleSearch = () => {
    const {query} = this.state;
    this.props.dispatch(getBrands(query));
  };

  handleClear = () => {
    this.setState({query: '',}, this.handleSearch);
  };

  render() {
    return (
      <Grid bsClass="container" fluid className="products accordion">
        <PageTitle>Brands</PageTitle>
        <Link to="/admin/brands/new">
          <ArrowButton color="red"
                       className="add-product"
                       submit={false}
                       arrow={false}
                       permissions={{
                         action: 'create',
                         subjectClass: 'Brand'
                       }}>Add brand</ArrowButton>
        </Link>

        <ProductSearchComponent searchValue={this.state.query}
                          onInputChange={this.handleInputChange}
                          onSearch={this.handleSearch}
                          onClear={this.handleClear}/>
        <BrandsList
          brands={this.props.brands}
          fetching={this.props.fetching}
          fetched={this.props.fetched}
        />
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    brands: state.brands.brands,
    fetched: state.brands.fetched,
    fetching: state.brands.fetching,
  };
};

export default connect(mapStateToProps)(Brands);


// WEBPACK FOOTER //
// ./src/components/admin/products/brands/list/index.jsx